/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.geometric-shapes\":\"Rectangle, ellipse, diamond and triangle shapes\"}");